import usePrivateAxios from '@/common/api/usePrivateAxios'
import {
  ProductsConsumptionInCurrentPeriodLimitsData,
  ProductsConsumptionInCurrentPeriodLimitsResponse,
} from '@/common/types/productsConsumptionInCurrentPeriodLimits.type'
import { UseQueryResult, useQuery } from '@tanstack/react-query'

interface UseProductsConsumptionInCurrentPeriodLimitsProps {
  cardId?: string
}

export const useProductsConsumptionInCurrentPeriodLimits: (
  props: UseProductsConsumptionInCurrentPeriodLimitsProps,
) => UseQueryResult<ProductsConsumptionInCurrentPeriodLimitsData, unknown> = ({ cardId }) => {
  const privateAxios = usePrivateAxios()

  return useQuery<
    ProductsConsumptionInCurrentPeriodLimitsResponse,
    unknown,
    ProductsConsumptionInCurrentPeriodLimitsData
  >({
    queryKey: ['productsConsumptionInCurrentPeriodLimits', cardId],
    queryFn: () => {
      return privateAxios.get(`/cards/${cardId}/products_consumption_in_current_period_limits`)
    },
    select: (data) => data?.data?.data,
  })
}
